module.exports = __webpack_public_path__ + "img/CM-BS-25-BMW-Established.3185e88b.jpg";